module.exports = __webpack_public_path__ + "img/hero-7.9c382f7b.png";